/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */
import DocumentsLandingPageWrapper from './DocumentsLandingPageWrapper';

export default DocumentsLandingPageWrapper;
